
export default {
    props: {
        productInfo: Array,
        activePromo: Object
    },
    data() {
        return {
            description: `As an All Access Student, you can stream this course on any device. However, if you'd like to download this course for offline access and own it forever, you can purchase this course now.`
        }
    },
}
